import './index.css';
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from 'react-share';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { View, Text } from '../../../component';
import { isMobileBrowser } from '../../../utilities/helper';
import { useDispatch } from 'react-redux';
import { showToast } from '../../../actions/app-actions-types';
import React from 'react';
interface Props {
  link?: any;
  contestTitle?: any;
  visible?: any;
  onPressDismiss?: any;
}

const ContestShare = ({ link, contestTitle, visible, onPressDismiss }: Props) => {
  const dispatch = useDispatch();
  const bottomSheetWidth = isMobileBrowser ? 'root_mobile' : 'root';
  const className = `${bottomSheetWidth}`;
  const iconSize = 40;
  const iconBorder = 40;
  const copyToClipBoard = async () => {
    try {
      await navigator.clipboard.writeText(link);
      dispatch(showToast('Link copied successfully'));
      onPressDismiss();
      // eslint-disable-next-line no-empty
    } catch (err) {}
  };
  return (
    <BottomSheet className={className} onDismiss={onPressDismiss} open={visible}>
      <View className={'contest-share-wrapper'}>
        <Text className={'contest-share-modal-title'}>{'Share Contest'}</Text>
        <View className={'contest-share-container'}>
          <TwitterShareButton
            url={link}
            className="contest-share-btn-container "
            title={contestTitle}>
            <TwitterIcon size={iconSize} borderRadius={iconBorder} round={true} />
          </TwitterShareButton>
          <FacebookShareButton
            url={link}
            className="contest-share-btn-container "
            title={contestTitle}>
            <FacebookIcon size={iconSize} borderRadius={iconBorder} round={true} />
          </FacebookShareButton>
          <EmailShareButton
            url={link}
            className="contest-share-btn-container "
            title={contestTitle}>
            <EmailIcon size={iconSize} borderRadius={iconBorder} round={true} />
          </EmailShareButton>
          <LinkedinShareButton
            url={link}
            className="contest-share-btn-container "
            title={contestTitle}>
            <LinkedinIcon size={iconSize} borderRadius={iconBorder} round={true} />
          </LinkedinShareButton>
          <TelegramShareButton
            url={link}
            className="contest-share-btn-container "
            title={contestTitle}>
            <TelegramIcon size={iconSize} borderRadius={iconBorder} round={true} />
          </TelegramShareButton>
          <WhatsappShareButton
            url={link}
            className="contest-share-btn-container "
            title={contestTitle}>
            <WhatsappIcon size={iconSize} borderRadius={iconBorder} round={true} />
          </WhatsappShareButton>
        </View>
        <View className={'contest-share-copy-btn-container'}>
          <Text className={'contest-share-link-title'}>{link}</Text>
          <View onPress={copyToClipBoard}>
            <Text className={'contest-share-copy-title'}>{'Copy'}</Text>
          </View>
        </View>
      </View>
    </BottomSheet>
  );
};
export default React.memo(ContestShare);
